import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";
import * as _ from "lodash";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Receipt } from "../models/receipt.model";

import "firebase/firestore";
import { AngularFireFunctions } from "@angular/fire/functions";

@Injectable({
  providedIn: "root",
})
export class ReceiptService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Receipt>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private fns: AngularFireFunctions,
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getReceipts(
    shopId: string,
    fromDate: Date,
    toDate: Date,
  ): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("issueDate", ">=", fromDate)
        .where("issueDate", "<=", toDate)
        .orderBy("issueDate", "desc"),
    );
  }

  getReceiptDeliveries(
    shopId: string,
    fromDate: Date,
    toDate: Date,
  ): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("isClosed", "==", true)
        .where("isDelivery", "==", true)
        .where("deliveryDate", ">=", fromDate)
        .where("deliveryDate", "<=", toDate)
        .orderBy("deliveryDate", "desc"),
    );
  }

  getReceiptsByCustomer(
    shopId: string,
    customerId: string,
    fromDate: Date,
    toDate: Date,
  ): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("customerId", "==", customerId)
        .where("issueDate", ">=", fromDate)
        .where("issueDate", "<=", toDate)
        .limit(10000)
        .orderBy("issueDate", "desc"),
    );
  }

  getReceiptTradesByCustomer(
    shopId: string,
    customerId: string,
  ): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("isCancel", "==", false)
        .where("isTrade", "==", true)
        .where("isClosed", "==", true)
        .where("customerId", "==", customerId)
        .orderBy("issueDate", "asc"),
    );
  }

  // getReceiptTradesCustomerByDate(
  //   shopId: string,
  //   customerId: string,
  //   fromDate: Date,
  //   toDate: Date
  // ): AngularFirestoreCollection<Receipt> {
  //   return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
  //     ref
  //       .where("isDeleted", "==", false)
  //       .where("isActive", "==", true)
  //       .where("isCancel", "==", false)
  //       .where("isTrade", "==", true)
  //       .where("isClosed", "==", true)
  //       .where("customerId", "==", customerId)
  //       .where("issueDate", ">=", fromDate)
  //       .where("issueDate", "<=", toDate)
  //       .orderBy("issueDate", "asc")
  //   );
  // }

  getReceiptTradesCustomerByDate(
    shopId: string,
    customerId: string,
    fromDate: Date,
    toDate: Date,
  ) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/receipts`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("isCancel", "==", false)
      .where("isTrade", "==", true)
      .where("isClosed", "==", true)
      .where("customerId", "==", customerId)
      .where("issueDate", ">=", fromDate)
      .where("issueDate", "<=", toDate)
      .orderBy("issueDate", "asc");

    return ref.get();
  }

  getReceiptsByUser(
    shopId: string,
    uid: string,
    fromDate: Date,
    toDate: Date,
  ): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("createdBy", "==", uid)
        .where("issueDate", ">=", fromDate)
        .where("issueDate", "<=", toDate)
        .orderBy("issueDate", "desc"),
    );
  }

  getReceiptsByIssueDate(
    shopId: string,
    type: string,
    issueDate: Date,
  ): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) => {
      let query: CollectionReference | Query = ref;
      let year = issueDate.getFullYear();
      let month = issueDate.getMonth() + 1;
      let day = issueDate.getDate();
      console.log(`getReceiptsByIssueDate: ${day}/${month}/${year}`);

      query = query.where("isDeleted", "==", false);
      query = query.where("isActive", "==", true);
      query = query.where("issueDateYear", "==", year);
      query = query.where("issueDateMonth", "==", month);

      if (type === "day") {
        query = query.where("issueDateDay", "==", day);
      }

      query = query.orderBy("issueDate", "desc");

      return query;
    });
  }

  getReceiptsByIssueDateCustomer(
    shopId: string,
    customerId: string,
    type: string,
    issueDate: Date,
  ): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) => {
      let query: CollectionReference | Query = ref;
      let year = issueDate.getFullYear();
      let month = issueDate.getMonth() + 1;
      let day = issueDate.getDate();
      console.log(`getReceiptsByIssueDate: ${day}/${month}/${year}`);

      query = query.where("isDeleted", "==", false);
      query = query.where("isActive", "==", true);
      query = query.where("customerId", "==", customerId);
      query = query.where("issueDateYear", "==", year);
      query = query.where("issueDateMonth", "==", month);

      if (type === "day") {
        query = query.where("issueDateDay", "==", day);
      }

      query = query.orderBy("issueDate", "desc");

      return query;
    });
  }

  getOpenReceipts(
    shopId: string,
    uid: string,
    isClosed: boolean,
    issueDate?: Date,
  ): AngularFirestoreCollection<Receipt> {
    const issueDateYear = issueDate.getFullYear();
    const issueDateMonth = issueDate.getMonth() + 1;
    const issueDateDay = issueDate.getDate();

    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("isCancel", "==", false)
        .where("isClosed", "==", isClosed)
        .where("createdBy", "==", uid)
        .where("issueDateYear", "==", issueDateYear)
        .where("issueDateMonth", "==", issueDateMonth)
        .where("issueDateDay", "==", issueDateDay)
        .orderBy("issueDate", "desc"),
    );
  }

  getReceiptsInventory(shopId: string): AngularFirestoreCollection<Receipt> {
    return this.db.collection(this.dbPath + `/${shopId}/receipts`, (ref) =>
      ref
        .where("isClosed", "==", true)
        .where("isDetailChanged", "==", true)
        .orderBy("issueDate", "asc"),
    );
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/receipts`)
      .doc(id)
      .valueChanges();
  }

  getReceipt(shopId: string, id: string) {
    var db = firebase.default.firestore();
    var ref = db.collection(this.dbPath + `/${shopId}/receipts`).doc(id);

    return ref.get();
  }

  create(receipt: Receipt): any {
    let obj = _.clone(receipt);
    delete obj.id;
    obj.receiptDetails =
      receipt.receiptDetails.length > 0
        ? JSON.parse(JSON.stringify(receipt.receiptDetails))
        : [];

    obj.isDelivered = false;
    obj.deliveredDate = new Date();

    obj.isActive = true;
    obj.isDeleted = false;
    obj.createdOn = new Date();
    obj.createdBy = this.userLogin.uid;
    obj.updatedOn = new Date();
    obj.updatedBy = this.userLogin.uid;
    obj.author = this.userLogin;
    obj.visibility = this.visibility;
    obj.timestamp = new Date().getTime();

    obj.shopId = obj.shopId ? obj.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${receipt.shopId}/receipts`,
    );

    console.log("create receipt:", obj);

    return this.collRef.add({ ...obj }).then((docRef) => {
      receipt.id = docRef.id;
      receipt.author = this.userLogin;
      return receipt;
    });
  }

  update(receipt: Receipt): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${receipt.shopId}/receipts`,
    );

    console.log("update receipt:", receipt);

    return this.collRef.doc(receipt.id).update({
      issueDate: receipt.issueDate,
      issueDateSeconds: receipt.issueDateSeconds,
      issueDateMinutes: receipt.issueDateMinutes,
      issueDateHours: receipt.issueDateHours,
      issueDateDay: receipt.issueDateDay,
      issueDateWeekDay: receipt.issueDateWeekDay,
      issueDateMonth: receipt.issueDateMonth,
      issueDateYear: receipt.issueDateYear,
      code: receipt.code ? receipt.code : "",
      note: receipt.note ? receipt.note : "",
      tags: receipt.tags ? receipt.tags : [],
      status: receipt.status,
      warehouseId: receipt.warehouseId ? receipt.warehouseId : "",
      warehouseName: receipt.warehouseName ? receipt.warehouseName : "",
      customerId: receipt.customerId ? receipt.customerId : "",
      customerName: receipt.customerName ? receipt.customerName : "",
      customerMobile: receipt.customerMobile ? receipt.customerMobile : "",
      customerAddress: receipt.customerAddress ? receipt.customerAddress : "",
      customerTaxCode: receipt.customerTaxCode ? receipt.customerTaxCode : "",
      lastDebitAmount: receipt.lastDebitAmount ? receipt.lastDebitAmount : 0,

      totalDiscountAmount: receipt.totalDiscountAmount,
      detailDiscountAmount: receipt.detailDiscountAmount,
      discountAmount: receipt.discountAmount,
      discountPercent: receipt.discountPercent,
      detailAmount: receipt.detailAmount,
      detailNetAmount: receipt.detailNetAmount,
      totalQuantity: receipt.totalQuantity,
      totalAmount: receipt.totalAmount,
      vatPercent: receipt.vatPercent,
      vatAmount: receipt.vatAmount,
      points: receipt.points,
      ratePoints: receipt.ratePoints,
      isCancel: receipt.isCancel,
      isClosed: receipt.isClosed,
      isPrint: receipt.isPrint,
      noPrint: receipt.noPrint,
      isTrade: !!receipt.isTrade,
      totalCostAmount: receipt.totalCostAmount ? receipt.totalCostAmount : 0,
      totalProfit: receipt.totalProfit ? receipt.totalProfit : 0,

      isDebit: !!receipt.isDebit,
      isCash: receipt.isCash,
      paymentAmount: receipt.paymentAmount,
      paymentRefund: receipt.paymentRefund,
      paymentId: receipt.paymentId ? receipt.paymentId : "",
      receiptDetails:
        receipt.receiptDetails.length > 0
          ? JSON.parse(JSON.stringify(receipt.receiptDetails))
          : [],

      employeeSaleId: receipt.employeeSaleId ? receipt.employeeSaleId : "",
      employeeSaleName: receipt.employeeSaleName
        ? receipt.employeeSaleName
        : "",

      employeeCounSellorId: receipt.employeeCounSellorId
        ? receipt.employeeCounSellorId
        : "",
      employeeCounSellorName: receipt.employeeCounSellorName
        ? receipt.employeeCounSellorName
        : "",

      employeeDeliveryId: receipt.employeeDeliveryId
        ? receipt.employeeDeliveryId
        : "",
      employeeDeliveryName: receipt.employeeDeliveryName
        ? receipt.employeeDeliveryName
        : "",

      isDelivery: !!receipt.isDelivery,
      deliveryDate: receipt.deliveryDate ? receipt.deliveryDate : new Date(),
      deliveryNote: receipt.deliveryNote ? receipt.deliveryNote : "",

      sharedLinkId: receipt.sharedLinkId ? receipt.sharedLinkId : "",

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  updateDelivery(receipt: Receipt): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${receipt.shopId}/receipts`,
    );

    console.log("updateDelivery:", receipt);

    return this.collRef.doc(receipt.id).update({
      employeeDeliveryId: receipt.employeeDeliveryId
        ? receipt.employeeDeliveryId
        : "",
      employeeDeliveryName: receipt.employeeDeliveryName
        ? receipt.employeeDeliveryName
        : "",

      isDelivery: !!receipt.isDelivery,
      deliveryDate: receipt.deliveryDate ? receipt.deliveryDate : new Date(),
      deliveryNote: receipt.deliveryNote ? receipt.deliveryNote : "",

      isDelivered: !!receipt.isDelivered,
      deliveredDate: receipt.deliveredDate ? receipt.deliveredDate : new Date(),
      deliveredNote: receipt.deliveredNote ? receipt.deliveredNote : "",
      deliveredAmount: receipt.deliveredAmount ? receipt.deliveredAmount : 0,

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  cancel(shopId: string, id: string, status: string, reason: string) {
    // const updatedOn = new Date();
    // const updatedBy = this.userLogin.uid;
    // this.collRef = this.db.collection(this.dbPath + `/${shopId}/receipts`);
    // return this.collRef.doc(id).update({
    //   isCancel: true,
    //   status: status,
    //   updatedOn: updatedOn,
    //   updatedBy: updatedBy,
    //   timestamp: new Date().getTime(),
    // });

    const callable = this.fns.httpsCallable("services-receipt-cancel");
    return callable({
      id: id,
      shopId: shopId,
      status: status,
      reason: reason,
    });
  }

  rePrint(shopId: string, id: string, noPrint: number): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/receipts`);
    return this.collRef.doc(id).update({
      isPrint: true,
      noPrint: noPrint,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  closed(shopId: string, id: string) {
    const callable = this.fns.httpsCallable("services-receipt-closed");
    return callable({
      id: id,
      shopId: shopId,
    });
  }

  unlock(shopId: string, id: string) {
    // const updatedOn = new Date();
    // const updatedBy = this.userLogin.uid;
    // this.collRef = this.db.collection(this.dbPath + `/${shopId}/receipts`);
    // return this.collRef.doc(id).update({
    //   isClosed: false,
    //   updatedOn: updatedOn,
    //   updatedBy: updatedBy,
    //   timestamp: new Date().getTime(),
    // });

    const callable = this.fns.httpsCallable("services-receipt-unlock");
    return callable({
      id: id,
      shopId: shopId,
    });
  }

  delete(shopId: string, id: string) {
    // const updatedOn = new Date();
    // const updatedBy = this.userLogin.uid;
    // this.collRef = this.db.collection(this.dbPath + `/${shopId}/receipts`);
    // return this.collRef.doc(id).update({
    //   isDeleted: true,
    //   updatedOn: updatedOn,
    //   updatedBy: updatedBy,
    //   timestamp: new Date().getTime(),
    // });

    const callable = this.fns.httpsCallable("services-receipt-delete");
    return callable({
      id: id,
      shopId: shopId,
    });
  }
}
